import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
var _excluded = ["size", "color", "selected", "allowMultiline"];
var _templateObject;
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import styled from 'styled-components';
import { Chip } from '@material-ui/core';
import { COLORS } from "../../constants/colors";
import { spacing } from '@material-ui/system';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export var _Chip = styled(function (_ref) {
  var size = _ref.size,
    color = _ref.color,
    selected = _ref.selected,
    allowMultiline = _ref.allowMultiline,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Chip, rest);
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.MuiChip-deletable:focus {\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &[href].MuiChip-clickable:hover {\n    text-decoration: underline;\n  }\n\n  &.MuiChip-clickable:hover {\n    ", ";\n  }\n\n  &.MuiChip-clickable:focus {\n    ", ";\n  }\n\n  &.MuiChip-root {\n    border: solid 1px\n      ", ";\n    background-color: ", ";\n    color: ", ";\n    height: ", ";\n    box-sizing: border-box;\n    border-radius: 100px;\n    padding: ", ";\n\n    ", "\n  }\n\n  & .MuiChip-deleteIcon {\n    margin: 0px;\n    margin-left: 8px;\n    color: ", ";\n\n    * {\n      color: ", ";\n    }\n  }\n\n  & .MuiChip-icon {\n    margin: 0px;\n    color: ", ";\n\n    * {\n      color: ", ";\n    }\n  }\n\n  & .MuiChip-label {\n    padding: 0px;\n    margin: 0px 4px;\n    display: flex;\n    align-items: center;\n  }\n\n  &.MuiChip-root > svg:first-child {\n    flex-shrink: 0;\n  }\n"])), function (props) {
  return COLORS.notification[props.color].light;
}, function (props) {
  return COLORS.notification[props.color].dark;
}, function (props) {
  return COLORS.notification[props.color].hoverBackground ? "background-color: ".concat(COLORS.notification[props.color].hoverBackground) : '';
}, function (props) {
  return COLORS.notification[props.color].focusBackground ? "background-color: ".concat(COLORS.notification[props.color].focusBackground) : '';
}, function (props) {
  return props.selected ? COLORS.notification[props.color].border : 'transparent';
}, function (props) {
  return props.selected ? COLORS.notification[props.color].selectedBackground : COLORS.notification[props.color].light;
}, function (props) {
  return COLORS.notification[props.color].dark;
}, function (props) {
  if (props.allowMultiline) {
    return 'auto';
  }
  return props.size === 'regular' ? '40px' : '32px';
}, function (props) {
  if (props.allowMultiline) {
    return '8px 12px';
  }
  return '0px 12px';
}, spacing, function (props) {
  return COLORS.notification[props.color].dark;
}, function (props) {
  return COLORS.notification[props.color].dark;
}, function (props) {
  return COLORS.notification[props.color].dark;
}, function (props) {
  return COLORS.notification[props.color].dark;
});